<app-header-three></app-header-three>
<!-- Login Form Start -->
<div class="section">

    <div class="imgs-wrapper">
      <img src="assets/img/veg/11.png" alt="veg" class="d-none d-lg-block">
      <img src="assets/img/veg/2.png" style="bottom: 100px" alt="veg" class="d-none d-lg-block">
    </div>

    <div class="container">
      <div class="auth-wrapper">

        <div class="auth-description bg-cover bg-center dark-overlay dark-overlay-2" style="background-image: url('assets/img/veg/cta-2.jpg')">
          <div class="auth-description-inner">
            <i class="flaticon-chili"></i>
            <h2>Welcome Back!</h2>
          </div>
        </div>
        <div class="auth-form">

          <h2>Log in</h2>

		<form [formGroup]="loginForm" class="login-container" (ngSubmit)="login()" autocomplete="off">
			<p class="invalid-login-msg">{{loginErrorMessage}}</p>
            <div class="form-group">
				<span [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
				<input type="email" formControlName="email" class="form-control form-control-light" placeholder="Email" name="username" autocomplete="off">
				</span>
				 <div  *ngIf="formControls.email.errors"
				  style="text-align: left;color: red;">
					<span *ngIf="formControls.email.errors.email">Email must be a valid email address</span>
				  </div>
			</div>
            <div class="form-group">
				<p [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
				<input type="password" formControlName="password" 
				class="form-control form-control-light"
				placeholder="Password" name="password" id="new-password" autocomplete="new-password">
				</p>
			</div>
            <a (click)="forGotPassword()" style="cursor: pointer">Forgot Password?</a>
            <button type="submit" class="btn btn-primary btn-block" *ngIf="!loginSpin" style="background: #ED4E53;border: unset;">Login</button>
			<div class="auth-seperator m-0">
              <span>OR</span>
            </div>
			<button type="submit" class="btn btn-success btn-block"  (click)="loginGuestProccess()"  *ngIf="!loginSpin">Login As Guest</button>

			<div  *ngIf="loginSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>	
          

            <div class="social-login">
              <div  *ngIf="loginSpinFacebook" class="category-box-icon d-flex mb-2">
				<i class="fas fa-spinner spinner"></i>
			  </div>
			  <button *ngIf="!loginSpinFacebook" type="button" class="ct-social-login facebook d-none"
			  (click)="signInWithFacebook()"
			  ><i class="fab fa-facebook-f"></i> Continue with Facebook </button>
              <div  *ngIf="loginSpinGoogle" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			  </div>
			  
			  <button *ngIf="!loginSpinGoogle" type="button" class="d-none  ct-social-login google"

			  (click)="signInWithGoogle()"><i class="fab fa-google"></i> Continue with Google</button>
            </div>

            <p>Don't have an account? <a routerLink='/register'>Create One</a> </p>

          </form>
        </div>

      </div>
    </div>
  </div>
  <!-- Modal -->
<div class="modal fade" id="forgotPassword" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Forgot Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
	  <form [formGroup]="forgotForm"  (ngSubmit)="forGot()" autocomplete="off">
	  <div class="modal-body">
	 	 <div *ngIf="forGotPasswordMessageApi!=''" class="alert alert-primary">
				  <strong> {{forGotPasswordMessageApi}} </strong>
		  </div>
		  <div class="form-group">
			<label for="exampleInputEmail1">Email address</label>
			<p [ngClass]="{ 'has-error': isSubmittedForgot && formControlsforgot.forgotemail.errors }">
				<input type="email" formControlName="forgotemail" 
				class="form-control form-control-light"
				placeholder="Email" name="forgotemail" value="">
			</p>
			
			<div  *ngIf="formControlsforgot.forgotemail.errors"
			  style="text-align: left;color: red;">
				<span *ngIf="formControlsforgot.forgotemail.errors.email">Email must be a valid email address</span>
		    </div>
			
		  </div>
	  </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
		<div  *ngIf="forGotPasswordSpin" class="category-box-icon d-flex">
			<i class="fas fa-spinner spinner"></i>
		</div>
		<button type="submit" class="btn btn-primary"  *ngIf="!forGotPasswordSpin">Submit</button>
      </div>
	  </form>

    </div>
  </div>
</div>
  <!-- Login Form End -->
<app-footer></app-footer>